// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__SQnzH"};